module.exports = __webpack_public_path__ + "static/Redux-Forms-10ae9de313a6f7702f778a3853929afe.png";